import { getFeatureEnabled, FeatureEnabledV2, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __assign, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { mapToAmlStatus } from '@gig/magic-sdk';
import { AML_STATUS_UPDATED, AML_STATUS_QUERY, COREX_AML_FILES_QUERY, RESET_FORM, Feature } from '@gig/magic-messages';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';
import { DocumentType, AmlStatus } from '@gig/magic-sdk/dist/adapter/users/getAmlStatus';
import { createUserDocument, uploadFile } from '../../sdk/file-upload-sdk.js';
import { getCategoryByDocumentType } from '../verification-upload-form/form-config/document-type.config.js';

var DOCUMENT_SECTIONS = [
    {
        type: DocumentType.PHOTO_ID,
        hasIdSelector: true,
        key: 'verification.id-proof',
        id: 'verification-upload-photo-id',
    },
    {
        type: DocumentType.ADDRESS,
        key: 'verification.address-proof',
        id: 'verification-upload-address',
    },
    {
        type: DocumentType.PAYMENT,
        key: 'verification.payment-proof',
        id: 'verification-upload-payment',
    },
    {
        type: DocumentType.SOURCE_OF_FUNDS,
        key: 'verification.sof-proof',
        id: 'verification-upload-sof',
    },
];
var VerificationComponent = /** @class */ (function (_super) {
    __extends(VerificationComponent, _super);
    function VerificationComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isIdScanEnabled = false;
        _this.isAddressScanEnabled = false;
        _this.alwaysAllowDocumentUpload = false;
        _this.disableManualUpload = false;
        _this.allowAllDocumentsUpload = false;
        _this.amlStatus = null;
        _this.isLoading = false;
        _this.scanIdVerified = false;
        _this.scanAddressVerified = false;
        _this.isScanError = false;
        _this.requirements = [];
        // allowAllDocumentsUpload = false;
        _this.userDocuments = [];
        return _this;
    }
    Object.defineProperty(VerificationComponent.prototype, "documentSections", {
        get: function () {
            var _this = this;
            return DOCUMENT_SECTIONS.filter(function (section) {
                if (!_this.amlStatus) {
                    return false;
                }
                return (_this.showAllDocuments ||
                    _this.amlStatus.status[section.type] !== AmlStatus.NOT_SET);
            }).map(function (section) {
                var type = section.type;
                if (!_this.amlStatus) {
                    return __assign(__assign({}, section), { files: [], status: null, uploadAllowed: false });
                }
                var filteredFiles = [];
                if (_this.userDocuments) {
                    filteredFiles = _this.userDocuments
                        .filter(function (file) {
                        return (file.category === getCategoryByDocumentType(type));
                    })
                        .map(function (file) {
                        // default data is not used e.g: kycId, statusId etc...
                        return {
                            kycId: 0,
                            statusId: 0,
                            statusMessage: '',
                            reasonText: '',
                            dateUploaded: file.createdOn,
                            helpText: '',
                            sowSupportDocType: '',
                            statusText: mapToAmlStatus(file.verificationStatus),
                            fileName: file.fileName,
                        };
                    });
                }
                return __assign(__assign({}, section), { files: filteredFiles, status: _this.amlStatus.status[type] });
            });
        },
        enumerable: false,
        configurable: true
    });
    VerificationComponent.prototype.shouldShowExtraText = function (section) {
        if (!section || !Array.isArray(section.files))
            return false;
        return section.files.some(function (file) { return file.statusText === 'Requested'; });
    };
    VerificationComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var urlParams;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        urlParams = new URLSearchParams(window.location.search);
                        if (urlParams.get('scan-verification') === 'complete') {
                            this.scanIdVerified = true;
                        }
                        if (urlParams.get('scan-address-verification') === 'complete') {
                            this.scanAddressVerified = true;
                        }
                        this.isLoading = true;
                        return [4 /*yield*/, Promise.all([this.fetchAMLStatus(), this.fetchUserDocuments()])];
                    case 1:
                        _a.sent();
                        this.setRequirements();
                        this.isLoading = false;
                        this.amlStatusUpdatedSubscription =
                            window.eventBus.subscribe(AML_STATUS_UPDATED, function (event) {
                                _this.amlStatus = event.payload;
                                _this.fetchUserDocuments();
                            });
                        return [2 /*return*/];
                }
            });
        });
    };
    VerificationComponent.prototype.destroyed = function () {
        var _a, _b;
        (_a = this.amlStatusUpdatedSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.amlFilesUpdatedSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    };
    VerificationComponent.prototype.fetchAMLStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(AML_STATUS_QUERY)];
                    case 1:
                        _a.amlStatus = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    VerificationComponent.prototype.fetchUserDocuments = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(COREX_AML_FILES_QUERY)];
                    case 1:
                        _a.userDocuments = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    VerificationComponent.prototype.setRequirements = function () {
        this.requirements = [
            { description: this.$t('verification.front-and-back'), label: 1 },
            { description: this.$t('verification.supported-files'), label: 2 },
            { description: this.$t('verification.file-max-size'), label: 3 },
        ];
    };
    VerificationComponent.prototype.onLanguageChange = function () {
        this.setRequirements();
    };
    VerificationComponent.prototype.onScanError = function () {
        this.isScanError = true;
        this.onError();
    };
    VerificationComponent.prototype.onCloseIframe = function () {
        if (this.scanAddressVerified) {
            return;
        }
        this.scanAddressVerified = true;
    };
    VerificationComponent.prototype.onError = function () {
        if (this.isScanError) {
            notificationService.show(this.$t('file-upload.scan.failed'), {
                style: NotificationStyle.ERROR,
                uniqueID: 'failed-scan-error',
            });
            this.isScanError = false;
        }
        else {
            notificationService.show(this.$t('verification.upload-error'), {
                style: NotificationStyle.ERROR,
                uniqueID: 'verification-upload-error',
            });
        }
    };
    VerificationComponent.prototype.fileSelected = function (params, section) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var idDocType_1, requestedDoc, _b, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!params.uploadFormValue) {
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 8, , 9]);
                        idDocType_1 = params.uploadFormValue.Type;
                        requestedDoc = (_a = this.userDocuments) === null || _a === void 0 ? void 0 : _a.find(function (doc) {
                            return doc.category === getCategoryByDocumentType(section.type) &&
                                doc.verificationStatus === AmlStatus.REQUESTED &&
                                doc.type === idDocType_1;
                        });
                        _b = this;
                        return [4 /*yield*/, getFeatureEnabled(Feature.ALLOW_ALL_DOCUMENTS_UPLOAD)];
                    case 2:
                        _b.allowAllDocumentsUpload = _c.sent();
                        if (!requestedDoc) return [3 /*break*/, 4];
                        return [4 /*yield*/, uploadFile({
                                file: params.file,
                                additionalParams: __assign(__assign({}, params.uploadFormValue), { Id: requestedDoc.id }),
                                onProgressChange: params.onProgressChange,
                            })];
                    case 3:
                        _c.sent();
                        return [3 /*break*/, 7];
                    case 4:
                        if (!this.allowAllDocumentsUpload) return [3 /*break*/, 6];
                        return [4 /*yield*/, createUserDocument({
                                file: params.file,
                                additionalParams: __assign(__assign({}, params.uploadFormValue), { type: idDocType_1 }),
                                onProgressChange: params.onProgressChange,
                            })];
                    case 5:
                        _c.sent();
                        return [3 /*break*/, 7];
                    case 6: return [2 /*return*/];
                    case 7:
                        this.onFileUploaded(section.type, idDocType_1);
                        window.eventBus.publish(RESET_FORM, true);
                        notificationService.show(this.$t('verification.upload-success'), {
                            style: NotificationStyle.SUCCESS,
                            uniqueID: 'verification-upload-success',
                        });
                        return [3 /*break*/, 9];
                    case 8:
                        e_1 = _c.sent();
                        this.onError();
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    VerificationComponent.prototype.onFileUploaded = function (docType, idDocType) {
        if (idDocType === void 0) { idDocType = null; }
        return {
            docType: docType,
            idDocType: idDocType,
        };
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], VerificationComponent.prototype, "hideIntroText", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], VerificationComponent.prototype, "showAllDocuments", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.SCAN_VERIFY_FLOW,
        }),
        __metadata("design:type", Object)
    ], VerificationComponent.prototype, "isIdScanEnabled", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.SCAN_DOCUMENTS_FLOW,
        }),
        __metadata("design:type", Object)
    ], VerificationComponent.prototype, "isAddressScanEnabled", void 0);
    __decorate([
        FeatureEnabledV2({
            slug: Feature.ALWAYS_ALLOW_DOCUMENT_UPLOAD,
        }),
        __metadata("design:type", Object)
    ], VerificationComponent.prototype, "alwaysAllowDocumentUpload", void 0);
    __decorate([
        FeatureEnabledV2({ slug: Feature.DISABLE_MANUAL_UPLOAD }),
        __metadata("design:type", Object)
    ], VerificationComponent.prototype, "disableManualUpload", void 0);
    __decorate([
        FeatureEnabledV2({ slug: Feature.ALLOW_ALL_DOCUMENTS_UPLOAD }),
        __metadata("design:type", Object)
    ], VerificationComponent.prototype, "allowAllDocumentsUpload", void 0);
    __decorate([
        Watch('magicConfig.language'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], VerificationComponent.prototype, "onLanguageChange", null);
    __decorate([
        Emit('fileUploaded'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", Object)
    ], VerificationComponent.prototype, "onFileUploaded", null);
    VerificationComponent = __decorate([
        Component({
            name: 'corex-verification',
        })
    ], VerificationComponent);
    return VerificationComponent;
}(Mixins(MagicConfigMixin)));

export default VerificationComponent;
